import { IconProps } from '.';
const DoorIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 34 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClasses}
      {...rest}
    >
      <g id="open-door">
        <g id="Vector">
          <path
            d="M13.6693 15.3333H17.0026V18.6667H13.6693V15.3333Z"
            fill={color || '#BABA04'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.1273 1.03243C21.4176 1.26984 21.5859 1.62502 21.5859 2.00001V31.5833H0.335938V29.0833H4.08594V5.03572C4.08594 4.44095 4.50503 3.92854 5.08799 3.81056L20.088 0.774849C20.4555 0.700466 20.837 0.795018 21.1273 1.03243ZM6.58594 29.0833H19.0859V3.52833L6.58594 6.05809V29.0833Z"
            fill={color || '#BABA04'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.6193 6.58334H20.3359V4.08334H28.8693C29.5596 4.08334 30.1193 4.64299 30.1193 5.33334V29.0833H33.6693V31.5833H27.6193V6.58334Z"
            fill={color || '#BABA04'}
          />
        </g>
      </g>
    </svg>
  );
};

export default DoorIcon;
